import { db } from '../db/database';
import type { OfflineSessionMarker } from '../db/database';

const OFFLINE_GRACE_PERIOD_MS = 72 * 60 * 60 * 1000;

export const OfflineSessionManager = {
  async saveMarker(data: Omit<OfflineSessionMarker, 'key'>): Promise<void> {
    await db.offlineSession.put({ ...data, key: 'current' });
  },

  async getMarker(): Promise<OfflineSessionMarker | null> {
    return (await db.offlineSession.get('current')) ?? null;
  },

  async isOfflineSessionValid(): Promise<boolean> {
    const marker = await this.getMarker();
    if (!marker) return false;
    return Date.now() - marker.lastServerValidation < OFFLINE_GRACE_PERIOD_MS;
  },

  async clearMarker(): Promise<void> {
    await db.offlineSession.clear();
  },

  async touchActivity(): Promise<void> {
    const marker = await this.getMarker();
    if (marker) {
      await db.offlineSession.put({ ...marker, lastActivity: Date.now() });
    }
  },

  async getGracePeriodRemaining(): Promise<number | null> {
    const marker = await this.getMarker();
    if (!marker) return null;
    const remaining =
      OFFLINE_GRACE_PERIOD_MS - (Date.now() - marker.lastServerValidation);
    return Math.max(0, remaining);
  }
};
